import { features } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
            Everything You Need in One{" "}
            <span className="text-accent-500">Hipobuy Spreadsheet</span> Hub
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-2xl mx-auto">
            Our platform combines powerful <strong>Hipobuy Spreadsheet</strong> tools with expert guidance to make product research faster and more effective.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-100 text-secondary-900 font-semibold text-sm rounded-full hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            Learn More About Our Features
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}